import { DonateButton } from 'ppp'
import { useProject } from 'shared'

export const DonateButtonLoader = ({ apiUrl, additionalClass }) => {
  const project = useProject(apiUrl)
  return <DonateButton
    additionalClass={additionalClass}
    project={project}
    status={project.status}
  />
}
